<!-- =========================================================================================
    File Name: TheFooter.vue
    Description: Footer component
    Component Name: TheFooter
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template functional>
    <footer class="the-footer" :class="classes">
      <div class="vx-row w-full">
        <div class="vx-col md:w-1/4 sm:w-1/3 w-full flex-grow md:flex md:items-center md:w-auto hidden justify-center">
          <!-- Logo -->
          <div tag="div" class="vx-logo flex items-center justify-center">
            <img class="mr-4 fill-current text-primary" src="@/assets/images/file-icons/logo-onde_thai.png" width="110">
            <img class="fill-current text-primary" src="@/assets/images/file-icons/logo-cmu.png" width="100">
          </div>
          <!-- /Logo -->
        </div>
        <div class="vx-col md:w-3/4 sm:w-2/3 w-full text-white">
          <h4 class="text-white mb-2">ติดต่อเรา</h4>
          <ul class="md:text-lg">
            <li>โครงการการบริหารจัดการปัญหาฝุ่นละอองขนาดเล็กในชุมชน</li>
            <li>ภาคเหนือตอนบนด้วยเครือข่ายเทคโนโลยีดิจิทัล</li>
            <li>เตือนภัยปริมาณฝุ่นละอองขนาดเล็กอัจฉริยะ</li>
            <li>239 ถนนห้วยแก้ว ตำบลสุเทพ อำเภอเมือง จังหวัดเชียงใหม่ 50200</li>
            <li>066-037-4422</li>
          </ul>
        </div>
      </div>

    </footer>
</template>

<script>
export default {
  name: 'the-footer',
  props: {
    classes: {
      type: String
    }
  }
}
</script>
